// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__2MZG_","iconContent":"checkbox_iconContent__AE6LR","icon":"checkbox_icon__3kEYN"};